// 取得網址參數
export const useUrlQuery = () => {
	const params = new URLSearchParams(window.location.search)

	const setQuery = (key, value) => {
		if (value) {
			params.set(key, value)
		} else {
			params.delete(key)
		}
		updateUrl()
	}

	const getQuery = (key) => {
		return params.get(key)
	}

	const updateMultipleQueries = (updates) => {
		Object.entries(updates).forEach(([key, value]) => {
			if (value) {
				params.set(key, value)
			} else {
				params.delete(key)
			}
		})
		updateUrl()
	}

	const getAllQueries = () => {
		return Object.fromEntries(params.entries())
	}

	const updateUrl = () => {
		const queryString = params.toString()
		const newUrl = queryString
			? `${window.location.pathname}?${queryString}`
			: window.location.pathname
		history.pushState({}, '', newUrl)
	}

	// 監聽瀏覽器的前進/後退
	window.addEventListener('popstate', () => {
		const newParams = new URLSearchParams(window.location.search)
		const updates = {}
		const allKeys = new Set([...params.keys(), ...newParams.keys()])

		allKeys.forEach(key => {
			const oldValue = params.get(key)
			const newValue = newParams.get(key)
			if (oldValue !== newValue) {
				updates[key] = newValue
			}
		})

		if (Object.keys(updates).length > 0) {
			window.dispatchEvent(new CustomEvent('query-change', {
				detail: { updates }
			}))
		}
	})

	return {
		setQuery,
		getQuery,
		updateMultipleQueries,
		getAllQueries
	}
}
